import PropTypes from 'prop-types';

import { ConfirmModalMobileViewStyled } from '../ConfirmModal.styles';

export default function ConfirmModalMobileView({ children, handleClose, ...rest }) {
  return (
    <ConfirmModalMobileViewStyled
      anchor="bottom"
      onClose={handleClose}
      open
      {...rest}
    >
      {children}
    </ConfirmModalMobileViewStyled>
  );
}

ConfirmModalMobileView.propTypes = {
  children: PropTypes.node.isRequired,
  handleClose: PropTypes.func.isRequired
};
